import { Injectable } from '@angular/core';
import { RawSequenceItemDefaultParams as DefaultParams } from '@app/models/raw-sequence-item-default-params.class';
import { RawSequenceItem, RawSequenceItemCreate } from '@app/models/raw-sequence-item.interface';
import { RawSequenceItemsService } from '@lib/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RawSequenceItemHelperService {

  constructor(
    private service: RawSequenceItemsService,
  ) { }

  getAll(): Observable<RawSequenceItem[]> {
    let params = new DefaultParams();
    return this.service.rawSequenceItemsGet(params)
      .pipe(map(x => <RawSequenceItem[]>x));
  }
  getById(id: number): Observable<RawSequenceItem> {
    let params = <any>new DefaultParams();
    params.id = 'eq.' + id;
    return this.service.rawSequenceItemsGet(params)
      .pipe(map(x => <RawSequenceItem>x[0]));
  }
  create(input: RawSequenceItemCreate) {
    return this.service.rawSequenceItemsPost({
      rawSequenceItems: <any>input,
      prefer: "return=representation"
    }, 'response')
    .pipe(map(response => response.body[0]))
    .pipe(map(body => {
      //console.log(body)
      return (<RawSequenceItem>body).id;
    }));
  }
  update(id: number, input: RawSequenceItemCreate) {
    return this.service.rawSequenceItemsPatch({
      id: 'eq.'+id,
      rawSequenceItems: <any>input
    }, 'response')
    .pipe(map(response => response.ok));
  }
}
